/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetPersonalDataInventoryPart } from './AssetPersonalDataInventoryPart';
import {
    AssetPersonalDataInventoryPartFromJSON,
    AssetPersonalDataInventoryPartFromJSONTyped,
    AssetPersonalDataInventoryPartToJSON,
    AssetPersonalDataInventoryPartToJSONTyped,
} from './AssetPersonalDataInventoryPart';
import type { AssetPersonalDataClientPart } from './AssetPersonalDataClientPart';
import {
    AssetPersonalDataClientPartFromJSON,
    AssetPersonalDataClientPartFromJSONTyped,
    AssetPersonalDataClientPartToJSON,
    AssetPersonalDataClientPartToJSONTyped,
} from './AssetPersonalDataClientPart';

/**
 * 
 * @export
 * @interface AssetPersonalDataResponse
 */
export interface AssetPersonalDataResponse {
    /**
     * 
     * @type {AssetPersonalDataClientPart}
     * @memberof AssetPersonalDataResponse
     */
    personalData: AssetPersonalDataClientPart;
    /**
     * 
     * @type {AssetPersonalDataInventoryPart}
     * @memberof AssetPersonalDataResponse
     */
    assetInventory: AssetPersonalDataInventoryPart;
}

/**
 * Check if a given object implements the AssetPersonalDataResponse interface.
 */
export function instanceOfAssetPersonalDataResponse(value: object): value is AssetPersonalDataResponse {
    if (!('personalData' in value) || value['personalData'] === undefined) return false;
    if (!('assetInventory' in value) || value['assetInventory'] === undefined) return false;
    return true;
}

export function AssetPersonalDataResponseFromJSON(json: any): AssetPersonalDataResponse {
    return AssetPersonalDataResponseFromJSONTyped(json, false);
}

export function AssetPersonalDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetPersonalDataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'personalData': AssetPersonalDataClientPartFromJSON(json['personalData']),
        'assetInventory': AssetPersonalDataInventoryPartFromJSON(json['assetInventory']),
    };
}

export function AssetPersonalDataResponseToJSON(json: any): AssetPersonalDataResponse {
    return AssetPersonalDataResponseToJSONTyped(json, false);
}

export function AssetPersonalDataResponseToJSONTyped(value?: AssetPersonalDataResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personalData': AssetPersonalDataClientPartToJSON(value['personalData']),
        'assetInventory': AssetPersonalDataInventoryPartToJSON(value['assetInventory']),
    };
}

